/**
 * 格式化日期为 YYYY/MM/DD HH:mm
 */
export function formatDrawDateTime(v) {
  if (v == null || v === '') return ''
  if (typeof v === 'string') {
    const d = new Date(v)
    if (!Number.isNaN(d.getTime())) {
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      const h = String(d.getHours()).padStart(2, '0')
      const min = String(d.getMinutes()).padStart(2, '0')
      return `${y}/${m}/${day} ${h}:${min}`
    }
    return v
  }
  return String(v)
}

/**
 * 格式化日期为 YYYY年MM月DD日（历史页用）
 */
export function formatHistoryDateLabel(v) {
  if (v == null || v === '') return ''
  const d = new Date(String(v).replace(' ', 'T'))
  if (Number.isNaN(d.getTime())) return String(v)
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${y}年${m}月${day}日`
}

/**
 * 解析开奖时间字符串为毫秒时间戳
 */
export function parseOpenTimeToMs(str) {
  if (str == null || str === '') return null
  const t = String(str).trim()
  let d = new Date(t.replace(' ', 'T'))
  if (Number.isNaN(d.getTime())) d = new Date(t.replace(/-/g, '/'))
  if (Number.isNaN(d.getTime())) return null
  return d.getTime()
}

/**
 * 根据上期开奖时间推算下期截止时刻
 * @param {'daily'|'hk246'} schedule
 */
export function nextDrawDeadlineFromLastMs(lastOpenMs, schedule) {
  if (lastOpenMs == null || !Number.isFinite(lastOpenMs)) return null
  const last = new Date(lastOpenMs)
  const h = last.getHours()
  const mi = last.getMinutes()
  const s = last.getSeconds()
  const ms = last.getMilliseconds()

  if (schedule === 'hk246') {
    const isHkDrawDay = wd => wd === 2 || wd === 4 || wd === 6
    let d = new Date(
      last.getFullYear(),
      last.getMonth(),
      last.getDate() + 1,
      h, mi, s, ms
    )
    for (let i = 0; i < 21; i++) {
      if (isHkDrawDay(d.getDay()) && d.getTime() > lastOpenMs) {
        return d.getTime()
      }
      d = new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1, h, mi, s, ms)
    }
    return null
  }

  const next = new Date(
    last.getFullYear(),
    last.getMonth(),
    last.getDate() + 1,
    h, mi, s, ms
  )
  return next.getTime()
}

/**
 * 期号 +1（支持补零期号如 049→50）
 */
export function issuePlusOne(issue) {
  const s = String(issue ?? '').trim()
  if (!s) return '—'
  const n = parseInt(s, 10)
  if (!Number.isNaN(n)) return String(n + 1)
  return s
}
